export class ParameterSMS {
   bId?: number;
   vizitReminder?: boolean;
   daysbefore?: number;
   hourSend: string | Date;
   bodyvizit: string;
   birthdayHourSend: string | Date;
   birthdayReminder?: boolean;
   birthdayMethod?: number;
   birthdayPeriodic?: number;
   bodyBirthday: string;
   creatingAppointmentReminder?: boolean;
   bodyCreatingAppointmentReminder: string;
   cancelingAppointmentReminder?: boolean;
   bodyCancelingAppointmentReminder: string;
   changingDateAppointmentReminder?: boolean;
   bodyChangingDateAppointmentReminder: string;
   changingTimeAppointmentReminder?: boolean;
   bodyChangingTimeAppointmentReminder: string;
   thankByRecommendationReminder?: boolean;
   bodyThankByRecommendationReminder: string;
   thankByMeetingReminder?: boolean;
   bodyThankByMeetingReminder: string
   minutesAfterPay?: number;
   automaticClosingCash?: boolean;
   sendReportCash?: boolean;
   bodySendReportCash: string;
   phone1SendReportCash: string;
   phone2SendReportCash: string;
   connection_string: string;
   isAddLink?: boolean;
}